import { Button } from '@/components';
import { NavigationPath } from '@/router/navigation-path.ts';
import { useNavigate } from 'react-router';
import Tooltip from '@/components/tooltip';
import { useSocket } from '@/providers/socket-io';
import ClassNames from 'classnames';
import { useDevicePermissions } from '@/context/device-permission-context';

type Props = {
	onSearchUser: () => void;
	isSearchDisabled?: boolean;
	isSearchLoading?: boolean;
	tooltipText?: string;
	waitingStudent?: number;
};

const InstantMeetingsDefaultState = ({ onSearchUser, isSearchDisabled = false, isSearchLoading = false, tooltipText = 'Şu anda başka bir görüşme için arama gerçekleştiriyorsunuz!', waitingStudent }: Props) => {
	const navigate = useNavigate();
	const { isConnected } = useSocket();
	const { controlPermission } = useDevicePermissions();

	const navigateToProviderTest = () => {
		controlPermission(() => navigate(NavigationPath.meetProviderTest));
	};

	const onClickSearchUser = () => {
		controlPermission(onSearchUser);
	};

	return (
		<div className={'coach-instant-meetings-container'}>
			<div className={'instant-meetings-info-container'}>
				<h1>Hazırsan Öğrenciler Seni Bekliyor!</h1>
				<p>Merak ettiklerini sormak veya rehberlik almak isteyen öğrencilerle anında bire bir görüşmeler gerçekleştirin.</p>
			</div>

			<div className={'instant-meetings-actions-container'}>
				<i className={'icons-user-circle'} />

				<div className={'waiting-user-container'}>
					<p className={'waiting-student-text'}>
						Şu an görüşme bekleyen <b>{waitingStudent} öğrenci</b>
						<br />
						bulunmaktadır.
					</p>
				</div>

				<Tooltip
					isVisible={isSearchDisabled}
					position={'top'}
					text={tooltipText}>
					<Button
						onClick={onClickSearchUser}
						disabled={isSearchDisabled || !isConnected || isSearchLoading}
						loading={isSearchLoading}>
						Öğrenci Ara
					</Button>
				</Tooltip>
			</div>

			<div className={'instant-meetings-footer'}>
				<button
					className={ClassNames('connection-test-button', {
						disabled: isSearchDisabled || !isConnected
					})}
					onClick={navigateToProviderTest}
					disabled={isSearchDisabled || !isConnected}>
					<i className={'icons-wifi'}></i>
					Bağlantını Test Et
				</button>
			</div>
		</div>
	);
};

export default InstantMeetingsDefaultState;
